import { RightOutlined } from '@ant-design/icons';
import React, { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import CheckboxGroup from './CheckboxGroup';
import DepartmentItemSelect from './DepartmentItemSelect';
import { BottomButton, Footer, Label, LittleTips } from './styles';
import { isTiKTok } from 'lib/utils/isTikTok';

export enum PlatformShopAuthWayType {
  Official,
  External,
}

export interface PlatformShopAuthWayProps {
  authWay: PlatformShopAuthWayType;
  onChange?: (value: PlatformShopAuthWayType) => void;
  departments: number[];
  setDepartments: (value: number[]) => void;
  onNext: () => void;
  platform: General.Platform;
}

const PlatformShopAuthWay = (props: PlatformShopAuthWayProps) => {
  const { authWay, departments, setDepartments, onChange, onNext, platform } = props;
  const { t } = useTranslate();

  let platformText: string = platform;
  if (platform === 'lazada') {
    platformText = 'Lazada';
  } else if (isTiKTok(platform)) {
    platformText = 'TikTok';
  }

  const authWayOptions: Array<{ value: PlatformShopAuthWayType; render: React.ReactNode }> =
    useMemo(
      () => [
        {
          value: PlatformShopAuthWayType.Official,
          render: t('authShop.authWayOption7'),
        },
        {
          value: PlatformShopAuthWayType.External,
          render: t('authShop.authWayOption8'),
        },
      ],
      [t],
    );

  const tipsMsg = useMemo(() => {
    if (authWay === PlatformShopAuthWayType.Official) {
      if (platform === 'lazada') {
        return t(
          '小提示：点击后自动打开Lazada卖家中心官网页面，进行必要的数据授权，站点（Site）需要选择跨境（Crossborder）',
        );
      }
      return t('authShop.小提示：点击后自动打开 Lazada 卖家中心官网页面，进行必要的数据授权', {
        platform: platformText,
      });
    }
    return null;
  }, [authWay, t, platformText, platform]);

  return (
    <div>
      <Label>{t('authShop.您可选择以下任意方式添加店铺')}</Label>
      <CheckboxGroup
        layout="vertical"
        value={authWay}
        options={authWayOptions}
        onChange={(val) => onChange && onChange(val as PlatformShopAuthWayType)}
      />

      {platform === 'lazada' ? null : (
        <div className="mt-4">
          <DepartmentItemSelect
            platform={platform}
            value={departments}
            onChange={setDepartments}
            showRequiredMark={false}
          />
        </div>
      )}

      <Footer className="flex-col items-center mt-[180px]">
        {tipsMsg ? <LittleTips type="info" message={tipsMsg} showIcon /> : null}
        <BottomButton size="large" type="primary" onClick={() => onNext()}>
          {authWay === PlatformShopAuthWayType.External
            ? t('authShop.复制链接')
            : t('authShop.下一步')}
          <RightOutlined />
        </BottomButton>
      </Footer>
    </div>
  );
};

export default PlatformShopAuthWay;
